import React from "react";

const BlogSkeleton: React.FC = () => {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[1, 2, 3].map((i) => (
                <div key={i} className="bg-terminal-background border border-terminal-subtle rounded-lg p-6 animate-pulse">
                    <div className="h-6 bg-terminal-subtle/30 rounded w-3/4 mb-4"></div>
                    <div className="h-4 bg-terminal-subtle/20 rounded w-1/2 mb-6"></div>
                    <div className="flex gap-2">
                        <div className="h-4 bg-terminal-subtle/10 rounded w-12"></div>
                        <div className="h-4 bg-terminal-subtle/10 rounded w-16"></div>
                    </div>
                    <div className="mt-8 font-mono text-terminal-text/20 text-xs">
                        {">"} LOADING_BLOCK_{i}...
                    </div>
                </div>
            ))}
        </div>
    );
};

export default BlogSkeleton;
